/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import Spinner from "components/spinner/spinner";
import Plus from "components/icons/plus";
import Button from "components/button/button";
import Close from "components/icons/close";
import { LoaderState } from "behaviors/loader/state";
import { TimeoutError } from "api/errors";
import { CustomURLNotFoundError } from "./errors";
import { t } from "i18n";

interface LoaderProps {
  loader: LoaderState;
  loadCustomUrls: () => void;
}

const Loader: React.SFC<LoaderProps> = ({ loader: { loading, error }, loadCustomUrls }) => {
  if (loading) {
    return <Spinner message={t("common.loading")} />;
  }
  if (error) {
    if (error instanceof TimeoutError) {
      return (
        <React.Fragment>
          <Plus width="48" height="48" />
          <p>Couldn't load the list</p>
          <p>
            <Button onClick={loadCustomUrls}>{t("common.retry")}</Button>
          </p>
        </React.Fragment>
      );
    }

    if (error instanceof CustomURLNotFoundError) {
      return (
        <React.Fragment>
          <Close width="48" height="48" />
          <p>{t("errors.not-found")}</p>
        </React.Fragment>
      );
    }
  }

  return <p>Unknown error</p>;
};

export default Loader;
